import { Company, PartialPermission, Branch, ActivationQRData } from "@/domain";

export function isBranchRestricted(permission: PartialPermission): boolean {
  return permission.branchIDs.length > 0;
}

export function branchComboItems(
  company: Company | null,
  permission: PartialPermission,
  selectAllLabel: string | null = null
): Branch[] {
  if (company) {
    return branchAddAllItem(
      company.branches || [],
      permission,
      selectAllLabel
        ? { id: -1, name: selectAllLabel, address: [], paymentLink: false, isVending: false, manualClose: false }
        : null
    );
  }
  return [];
}

export function branchAddAllItem<T>(branches: T[], permission: PartialPermission, allItem: T | null = null): T[] {
  const arr = [...branches];
  if (allItem && !isBranchRestricted(permission)) {
    arr.unshift(allItem);
  }
  return arr;
}

interface PackedQR {
  b: number; // branchID,
  t: number; // terminalID,
  c: string; // tcod
  n?: string; //networkConfiguration
}
export function packQRData(data: ActivationQRData): string {
  const packed: PackedQR = {
    b: data.branchID,
    t: data.terminalID,
    c: data.tcod
  };
  if (data.networkConfiguration) {
    packed.n = data.networkConfiguration;
  }
  return JSON.stringify(packed, undefined, 0);
}
